import { FC } from 'react'
import { ChartComponent } from './ChartComponent'

export type AverageWeightChartProps = {
  schoolColors: { [id: string]: string }
}

export const AverageWeightChart: FC<AverageWeightChartProps> = ({ schoolColors }) => {
  return <ChartComponent property={'averageWeight'} schoolColors={schoolColors} />
}
